import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const DocumentFilled = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        d="m19.39 6.77-3.95-3.82c-.31-.3-.73-.47-1.17-.47H7.69c-1.97 0-3.56 1.54-3.56 3.44v12.15c0 1.9 1.59 3.44 3.56 3.44h8.63c1.97 0 3.56-1.54 3.56-3.44V7.91c0-.43-.17-.83-.49-1.13v-.01Zm-3.45 9.94H8.23c-.43 0-.79-.35-.79-.79 0-.44.35-.79.79-.79h7.71c.43 0 .79.35.79.79 0 .44-.35.79-.79.79Zm0-3.94H8.23c-.43 0-.79-.35-.79-.79 0-.44.35-.79.79-.79h7.71c.43 0 .79.35.79.79 0 .44-.35.79-.79.79Zm-1.18-5.51V4.47l2.89 2.79h-2.89Z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default DocumentFilled
